import React from "react";
import {Query} from "react-apollo";
import gql from "graphql-tag";
import Button from "../../components/Button";

const PROCESS_STATUS = gql`
  query subscriptionProcessStatus($subscriptionId: ID!, $requestId: ID!) {
    subscriptionProcessStatus(subscriptionId: $subscriptionId, requestId: $requestId) {
      status
      message
      updatedAt
    }
  }
`

const POLL_INTERVAL = 2000;
const TIMER_WAIT = 4000; // 4 seconds

class PauseSubscriptionProgressForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      // Show a back button in case it takes too long and maybe we are stuck.
      showFallbackBackButton: false
    }
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    this.stopTimer();
  }  

  startTimer() {
    this.timeoutId = window.setTimeout(this.onTimer.bind(this), TIMER_WAIT)
  }

  stopTimer() {
    window.clearTimeout(this.timeoutId);
    this.timeoutId = null;
  }  

  onTimer() {
    this.setState({showFallbackBackButton: true});
  } 

  render() {
    let variables = {
      subscriptionId: this.props.subscriptionId,
      requestId: this.props.requestId
    }
    return (
      <div className="PauseSubscriptionProgressForm">
        <Query query={PROCESS_STATUS} variables={variables} pollInterval={POLL_INTERVAL} fetchPolicy="network-only">
          {({ loading, error, data, stopPolling }) => {
            if (loading) {
              return this.renderLoadingStatus();
            }

            if (error) {
              stopPolling();
              return this.renderFailed(error);
            }

            if (data.subscriptionProcessStatus.status === "failed") {
              stopPolling();
              return this.renderFailed();
            }

            if (data.subscriptionProcessStatus.status === "paused") {
              stopPolling();
              return this.renderCompleted();
            }

            if (data.subscriptionProcessStatus.status === "deferred") {
              stopPolling();
              return this.renderDeferred();
            }

            return this.renderLoadingStatus();
          }}
        </Query>            
      </div>
    )
  }

  renderLoadingStatus() {
    if (this.state.showFallbackBackButton) {
      return (
        <React.Fragment>
          <h2>Standby...</h2>
          <p>Please wait while we pause the subscription. It's taking longer than expected...</p>
          <Button label="Go back" onClick={this.props.onBack} />
        </React.Fragment>
      )
    } 

    return (
      <React.Fragment>
        <h2>Standby...</h2>
        <p>Please wait while we pause the subscription.</p>
      </React.Fragment>
    )
  }

  renderFailed(error) {
    return (
      <React.Fragment>
        <h2>Oh No!</h2>
        <p>Unfortunately the subscription could not be paused at this point. Please try again.</p>
        <Button label="Try again" onClick={this.props.onBack} />
      </React.Fragment>
    )
  }

  renderDeferred() {
    return (
      <React.Fragment>
        <h2>Ongoing Delivery</h2>
        <p>A delivery has already started and cannot be automatically paused. The subscription will automatically pause as soon as the delivery has been processed.</p>
        <Button label="Continue" onClick={this.props.onCompleted} />
      </React.Fragment>
    )
  }  

  renderCompleted() {
    return (
      <React.Fragment>
        <h2>All Done</h2>
        <p>The subscription was successfully paused.</p>
        <Button label="Continue" onClick={this.props.onCompleted} />
      </React.Fragment>
    )
  }  
}

export default PauseSubscriptionProgressForm;